import { useEffect } from 'react'
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import AOS from 'aos'
import 'aos/dist/aos.css'

const core = [
  {
    name: 'ASP.NET C# (Web and Desktop Apps)',
    value: 90,
    icon: CheckCircleIcon,
  },
  {
    name: 'ASP.NET Web API',
    value: 90,
    icon: CheckCircleIcon,
  },
  {
    name: 'Python (Django)',
    value: 85,
    icon: CheckCircleIcon,
  },
  {
    name: 'Android Development using MAUI',
    value: 80,
    icon: CheckCircleIcon,
  },
]
const frameWorks = [
  {
    name: 'Entity Framework',
    value: 85,
    icon: CheckCircleIcon,
  },
  {
    name: 'ADO.NET',
    value: 80,
    icon: CheckCircleIcon,
  },
  {
    name: 'React JS',
    value: 90,
    icon: CheckCircleIcon,
  },
  {
    name: 'JavaScript',
    value: 95,
    icon: CheckCircleIcon,
  },
  {
    name: 'CSS 3',
    value: 95,
    icon: CheckCircleIcon,
  },
  {
    name: 'HTML 5',
    value: 95,
    icon: CheckCircleIcon,
  },
]

const databases = [
  {
    name: 'MS SQL Server',
    value: 90,
    icon: CheckCircleIcon,
  },
  {
    name: 'PostgreSQL',
    value: 85,
    icon: CheckCircleIcon,
  },
  {
    name: 'Clickhouse DB',
    value: 80,
    icon: CheckCircleIcon,
  },
]

export default function Skills() {
  useEffect(() => {
    AOS.init({ duration: 2000 })
  }, [])
  return (
    <div className=" " id="skills">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-xl leading-7">Explore my</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight sm:text-6xl">
            Skills
          </p>
        </div>
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:gap-y-10">
          <div
            className="mt-10 max-w-2xl sm:mt-10 lg:mt-10 lg:max-w-4xl bg-base-200 ring-2 ring-base-300 rounded-2xl p-5 shadow-xl "
            data-aos="zoom-in"
          >
            <p className="text-2xl text-center font-bold mb-6">
              Key Competencies
            </p>
            <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-6 lg:max-w-none lg:grid-cols-2 lg:gap-y-6">
              {core.map((core) => (
                <div key={core.name} className="relative pl-16">
                  <dt className="text-base font-semibold leading-7">
                    <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg">
                      <core.icon className="h-6 w-6" aria-hidden="true" />
                    </div>
                    {core.name}
                  </dt>
                  <dd className="mt-2 text-base leading-7">
                    <progress
                      className="progress w-3/4"
                      value={core.value}
                      max="100"
                    ></progress>
                  </dd>
                </div>
              ))}
            </dl>
          </div>
          <div
            className="mt-10 max-w-2xl sm:mt-10 lg:mt-10 lg:max-w-4xl bg-base-200 ring-2 ring-base-300 rounded-2xl p-5 shadow-xl"
            data-aos="zoom-in"
          >
            <p className="text-2xl text-center font-bold mb-6">
              Front-end & Frameworks
            </p>
            <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-6 lg:max-w-none lg:grid-cols-2 lg:gap-y-6">
              {frameWorks.map((fw) => (
                <div key={fw.name} className="relative pl-16">
                  <dt className="text-base font-semibold leading-7">
                    <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg">
                      <fw.icon className="h-6 w-6" aria-hidden="true" />
                    </div>
                    {fw.name}
                  </dt>
                  <dd className="mt-2 text-base leading-7">
                    <progress
                      className="progress w-3/4"
                      value={fw.value}
                      max="100"
                    ></progress>
                  </dd>
                </div>
              ))}
            </dl>
          </div>
          <div
            className="mt-10 max-w-2xl sm:mt-10 lg:mt-10 lg:max-w-4xl bg-base-200 ring-2 ring-base-300 rounded-2xl p-5 shadow-xl"
            data-aos="zoom-in"
          >
            <p className="text-2xl text-center font-bold mb-6">Databases</p>
            <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-6 lg:max-w-none lg:grid-cols-2 lg:gap-y-6">
              {databases.map((db) => (
                <div key={db.name} className="relative pl-16">
                  <dt className="text-base font-semibold leading-7">
                    <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg">
                      <db.icon className="h-6 w-6" aria-hidden="true" />
                    </div>
                    {db.name}
                  </dt>
                  <dd className="mt-2 text-base leading-7">
                    <progress
                      className="progress w-3/4"
                      value={db.value}
                      max="100"
                    ></progress>
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </div>
  )
}
